import React from 'react'

import styled from '@emotion/styled'

const Accordian = ({ label, content, isOpened }) => {
  return (
    <Container>
      <Question>
        <Span>Q. </Span>
        {label}
      </Question>
      {isOpened && (
        <Answer>
          <Span>A. </Span>
          {content}
        </Answer>
      )}
    </Container>
  )
}

export default Accordian

const Container = styled.div``

const Question = styled.div`
  width: 100%;
  padding: 32px;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
`

const Span = styled.span`
  color: #ff4a52;
  font-weight: 900;
`

const Answer = styled.div`
  padding: 32px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #e8e8e8;
`
